"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _SendFormComponent = _interopRequireDefault(require("./SendFormComponent"));
var _kycLevelsSelectors = require("./../../../redux/selectors/kycLevelsSelectors");
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var formValue = (0, _reduxForm.formValueSelector)('SendForm');
  var _kycVerificationLevel = (0, _kycLevelsSelectors.kycVerificationLevelsSelector)(state),
    disableWithdraw = _kycVerificationLevel.disableWithdraw;
  var userEmail = state.user.userInfo.Email;
  var withdrawError = !!state.withdraw.error;
  return {
    disableWithdraw: disableWithdraw,
    userEmail: userEmail,
    withdrawError: withdrawError,
    Amount: formValue(state, 'Amount')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    verificationOnClick: function verificationOnClick() {
      return dispatch((0, _sidePaneActions.closeSidePane)());
    }
  };
};
var SendForm = (0, _reduxForm.reduxForm)({
  form: 'SendForm',
  onSubmit: function onSubmit() {}
})(_SendFormComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SendForm);